import Vue from "vue";
import VueScrollReveal from "vue-scroll-reveal";

// Using ScrollReveal's default configuration
Vue.use(VueScrollReveal);
